export default [
  {
    id: "1069276121628934144",
    parentId: "0",
    menuName: "基本信息",
    menuNameEn: null,
    menuType: 1,
    icon: "iconfont icon-caidan",
    router: "/home",
    perms: "",
    remark: "",
    isVisible: 1,
    isFrame: 0,
    sort: 0,
    state: 1,
    children: []
  }
]